import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { copy } from '../../copy/es';
import { api, ErrorApi, textoDeError } from '../../lib/api';
import { useSesion } from '../sesion';

/** Mockup screen 1: admin sign-in. Third parties never see this (HU-1). */
export function IngresoPage() {
  const { recargar } = useSesion();
  const navegar = useNavigate();
  const [correo, setCorreo] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function ingresar(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await api('/api/admin/sesion', { method: 'POST', body: JSON.stringify({ correo, clave }) });
      await recargar();
      navegar('/admin/cargue', { replace: true });
    } catch (err) {
      if (err instanceof ErrorApi && err.codigo === 'CAMBIO_CLAVE_REQUERIDO') {
        await recargar();
        navegar('/admin/cambiar-clave', { replace: true });
        return;
      }
      setError(textoDeError(err));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="stage">
      <section className="screen">
        <div className="card sm">
          <div className="p-head">
            <span className="logo-wrap">
              <img className="logo" src="/coninsa-logo.svg" alt="Coninsa" />
            </span>
            <div className="right">
              <div className="t">{copy.admin.titulo}</div>
              <div className="by">{copy.app.gobernadoPor.toUpperCase()}</div>
            </div>
          </div>
          <form className="p-body" onSubmit={ingresar}>
            <h2>{copy.admin.ingresoTitulo}</h2>
            <p className="sub">{copy.admin.ingresoSubtitulo}</p>
            <div className="field">
              <label htmlFor="usr">{copy.admin.usuario}</label>
              <input
                id="usr"
                type="email"
                autoComplete="username"
                placeholder="usuario@coninsa.co"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="pwd">{copy.admin.contrasena}</label>
              <input
                id="pwd"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={clave}
                onChange={(e) => setClave(e.target.value)}
                required
              />
            </div>
            {error && (
              <div className="err" role="alert">
                {error}
              </div>
            )}
            <button className="cta" disabled={enviando}>
              {copy.admin.ingresar}
            </button>
            <div className="expira">{copy.admin.ingresoPie}</div>
          </form>
        </div>
        <div className="foot">{copy.app.pie}</div>
      </section>
    </div>
  );
}
